import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import LoginPage from "./Pages/LoginPage";
import RegisterPage from "./Pages/RegisterPage";
// import NavBar  from './components/NavBar';
import "./components/Navbar/NavBar.css";
import ContactPage from "./Pages/ContactPage";
import HomePage from "./Pages/HomePage";
import { useState } from "react";
import { TokenContext } from "./components/Contexts/TokenContext";


function App() {
 const [isToken,setIsToken] = useState(JSON.parse(localStorage.getItem("token")))
  return (
    <Router>
      <TokenContext.Provider value={{
        isToken,
        setIsToken
      }}>
        
      <div className="App h-full">
          <Routes>
            <Route path="/Login" element={<LoginPage setIsToken={setIsToken} />} />
            <Route path="/Register" element={<RegisterPage  />} />
            <Route path="/Contact" element={<ContactPage />} />
            <Route path="/Home" element={<HomePage />} />
          </Routes>
      </div>
      </TokenContext.Provider>
    </Router>
  );
}

export default App;
